import React, { useContext } from "react";
import { store } from "../../../Store";
import { Link } from "react-router-dom";
import { FocusScope } from "react-aria";

/**
 * Componente con las opciones Colegios, Bibliotecas y Familias
 * @param {Function} setOpenDropdown - actualiza el estado openDropdown
 * @param {boolean} openDropdown - estado que indica si se debe ver las opciones de planes
 * @param {object} textosInterfaz- contiene los textos de interfaz
 * @returns {JSX.Element} DropdownPlanes
 */
export const DropdownPlanes = ({ setOpenDropdown, openDropdown, textosInterfaz }) => {

  const globalState = useContext(store);
  const { state } = globalState;
  const country = state?.pais?.toLowerCase();

  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      setOpenDropdown(false);
    }
  };

  return (
    openDropdown && (
      <FocusScope contain restoreFocus autoFocus>
        <ul onKeyDown={handleKeyDown}>
          <li className={`${openDropdown ? 'activeMode' : 'inactiveMode'}`}>
            <Link
              to="/que-es/colegios"
              className="focusable-red"
              onClick={() => setOpenDropdown(false)}
            >{textosInterfaz?.colegios || 'Colegios'}</Link>
          </li>
          <li className={`${openDropdown ? 'activeMode' : 'inactiveMode'}`}>
            <Link
              to="/que-es/bibliotecas"
              className="focusable-red"
              onClick={() => setOpenDropdown(false)}
            >{textosInterfaz?.bibliotecas || 'Bibliotecas'}</Link>
          </li>

          {
            country !== 'us' &&
            <li className={`${openDropdown ? 'activeMode' : 'inactiveMode'}`}>
              <Link
                to="/tienda/plan-casa"
                className="focusable-red"
                onClick={() => setOpenDropdown(false)}
              >{textosInterfaz?.casa || 'Casa'}</Link>
            </li>
          }

          <li className={`close-options ${openDropdown ? 'activeMode' : 'inactiveMode'}`}>
            <button onClick={() => setOpenDropdown(false)} aria-label={textosInterfaz?.button_close_list_alt || "Cerrar la lista desplegable"} className="w-100 focusable-red ">
              {textosInterfaz?.button_close_list || "Cerrar"}
            </button>
          </li>
        </ul>

      </FocusScope>
    )
  )
}